import type { ReactNode } from "react";
type Props = {
	children: ReactNode;
};
export const Wrapper = (props: Props) => {
	const fontFamily = "font-PixelMplus10Regular";
	return <div className={`${fontFamily} text-white`}>{props.children}</div>;
};
